import { useMemo } from 'react';
import {
	PreWorkInterviewProvider,
	usePreWorkInterviewWizard,
} from './usePreWorkInterviewWizard';
import { PreWorkInterviewStep } from './PreWorkInterviewStep';
import { WizardContainer } from '../../../components/wizard/Wizard';
import { WizardProvider } from '../../../components/wizard/useWizard';
import {
	PRE_WORK_APPLICATIONS,
	PRE_WORK_MENTOR_CONTEXT,
} from '../../../shared/Routes';
import { UserRole } from '../../../shared/VolunteerApplicationServiceTypes';
import useUserSession from '../../../hooks/useUserSession';

export const PreWorkInterviewWizard = () => {
	const { onSubmitClick, onCancelClick } = usePreWorkInterviewWizard();
	const { selectedRole } = useUserSession();
	const isApprover = selectedRole === UserRole.APPROVER;
	const currentWizard = 0;
	const wizards = useMemo(
		() => [
			{
				steps: [<PreWorkInterviewStep key={1} />],
			},
		],
		[]
	);
	const steps = wizards[currentWizard].steps;

	return (
		<div className="flex flex-col h-full min-h-0 p-[8px]">
			<WizardContainer
				onSubmitClick={onSubmitClick}
				onCancelClick={onCancelClick}
				steps={steps}
				navigateTo={
					isApprover ? PRE_WORK_APPLICATIONS : PRE_WORK_MENTOR_CONTEXT
				}
			/>
		</div>
	);
};

export const PreWorkInterviewWizardContainer = () => {
	return (
		<PreWorkInterviewProvider>
			<WizardProvider>
				<PreWorkInterviewWizard />
			</WizardProvider>
		</PreWorkInterviewProvider>
	);
};
